import React, { Fragment } from 'react';
import {
  Page,
  Navbar,
  NavLeft,
  NavRight,
  NavTitle,
  Link,
  Block,
  BlockTitle,
  Toolbar,
  Tabs,
  Tab,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  List,
  ListInput,
  ListItem,
  Icon,
  Button,
  Row,
  Col,
  Checkbox,
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionToggle,
  Popup,
  Toggle,
  Preloader,
  Badge,
  Stepper,
  Popover,
} from 'framework7-react';

import { WalletSvg } from '../components/crumbs';

import moment from 'moment';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStorage, firestoreConnect } from '../HOCs';
import { Doc, DocArray, AssignedVendorsArray } from '../utils/_classes';
import {
  handleErrors,
  isEmpty,
  toast,
  generateId,
  fetchBanks,
  resolveAccountNumber,
  createTransferRecipient,
  deleteTransferRecipient,
  payStackTransferCharge,
  initiateATransfer,
  sendOneTimePassword,
  verifyOneTimePassword,
  addOrRemoveBank,
} from '../utils/_helpers';

class EasychawAgent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popupOpened: false,
      popupDataChanged: false,
      popupData: {
        title: '',
        which: '',
      },

      // Bank
      addBankButton: 'Upload Bank Details',
      bank: {
        bankName: '',
        accountName: '',
        accountNumber: '',
        sortCode: '',
        bankCode: '',
      },
      banks: [],
      BanksWithIssues: ['Parallex Bank'],

      // Withdrawals
      withdrawalButton: 'Confirm Transaction',
      withdrawalInfo: {
        recipientCode: '',
        amount: 0,
      },
    };
  }

  render() {
    if (!this.props.partners[this.props.auth.uid]) {
      return (
        <Page id="partners-page">
          <Navbar sliding={false} backLink="Back">
            <NavTitle sliding> Referral Dashboard</NavTitle>
          </Navbar>
          <Block
            style={{
              backgroundColor: '#b3e5ff',
              borderLeft: '3px solid #03a9f4',
              color: '#03a9f4',
              marginTop: 0,
              paddingTop: '16px',
              paddingBottom: '16px',
            }}>
            <small>Become an Easychaw agent &nbsp;&nbsp;&nbsp;</small>
            <Link
              style={{
                width: '45%',
                color: 'white',
                backgroundColor: '#03a9f4',
                display: 'inline',
                padding: '10px',
              }}
              href="/business-registration/3/">
              Easychaw Agent Sign Up
            </Link>
          </Block>
        </Page>
      );
    }

    if (this.props.partners[this.props.auth.uid].accountStatus == 'Pending') {
      return (
        <Page id="partners-page">
          <Navbar sliding={false} backLink="Back">
            <NavTitle sliding> Easychaw Agent Dashboard</NavTitle>
          </Navbar>
          <Block className="pab">
            <Row>
              <Col>
                <p>Application Pending &nbsp;&nbsp;&nbsp;</p>
              </Col>
              <Col>
                <Link
                  className="pal"
                  tabLink="#view-message-master"
                  onClick={() =>
                    this.navMessage('account', 'admin', 'account')
                  }>
                  Contact Admin
                </Link>
              </Col>
            </Row>
            <Row className="pat">
              <Col>
                <p style={{ margin: '0', color: ' #9E9E9E' }}>
                  Please contact Admin after 24 hours if account is still
                  pending.
                </p>
              </Col>
            </Row>
          </Block>
        </Page>
      );
    }

    if (this.props.partners[this.props.auth.uid].accountStatus == 'Suspended') {
      return (
        <Page id="partners-page">
          <Navbar sliding={false} backLink="Back">
            <NavTitle sliding> Easychaw Agent Dashboard</NavTitle>
          </Navbar>
          <Block className="sdab">
            <Row>
              <Col>
                <p>Account Suspended &nbsp;&nbsp;&nbsp;</p>
              </Col>
              <Col>
                <Link
                  className="sdal"
                  tabLink="#view-message-master"
                  onClick={() =>
                    this.navMessage('account', 'admin', 'account')
                  }>
                  Contact Admin
                </Link>
              </Col>
            </Row>
          </Block>
        </Page>
      );
    }

    return (
      <Page id="partners-page" onPageAfterIn={this.onPageAfterIn.bind(this)}>
        <Navbar sliding={false} backLink="Back">
          <NavTitle sliding> Easychaw Agent Dashboard</NavTitle>
        </Navbar>

        <Block>
          <Row>
            <Col width="100" className="xsmall-40 heightMeasure-1">
              {/* [Card-0] Brand Card*/}
              <div
                style={{
                  width: '103%',
                  paddingTop: '9px',
                  marginLeft: '-6px',
                  position: 'relative',
                }}>
                <WalletSvg id="agentcard" title="Referral Wallet" />
                {this.props.wallets &&
                this.props.wallets[
                  this.props.partners[this.props.auth.uid].walletId
                ] ? (
                  <span className="walletBalance">
                    {new Intl.NumberFormat('en-GB', {
                      style: 'currency',
                      currency: 'NGN',
                    }).format(
                      Number(
                        this.props.wallets[
                          this.props.partners[this.props.auth.uid].walletId
                        ].walletBalance
                      )
                    )}
                  </span>
                ) : (
                  <span className="walletBalance">NGN 0.00</span>
                )}
                <em className="walletBalanceSubText">Wallet Balance</em>
              </div>

              {/* [Card-1] Wallet History*/}
              <Card style={{ margin: '10pt auto' }}>
                <CardHeader>Wallet History</CardHeader>
                <CardContent>
                  <List noHairlinesMd>
                    <ListItem title="Total transactions">
                      <small slot="after">
                        {this.props.transactions.length || '0'}
                      </small>
                      <Icon f7="number_square" slot="media" />
                    </ListItem>
                    <ListItem title="Total amount Received">
                      <small slot="after">
                        {this.props.transactions.length > 0
                          ? new Intl.NumberFormat('en-GB', {
                              style: 'currency',
                              currency: 'NGN',
                            }).format(
                              this.props.transactions
                                .filter(
                                  (t) =>
                                    t.type === 'Received' &&
                                    t.status === 'Success'
                                )
                                .map((t) => t.amount)
                                .reduce((a, b) => +a + +b, 0)
                            )
                          : new Intl.NumberFormat('en-GB', {
                              style: 'currency',
                              currency: 'NGN',
                            }).format(0)}
                      </small>
                      <Icon f7="number_square" slot="media" />
                    </ListItem>
                    <ListItem title="Total amount withdrawn">
                      <small slot="after">
                        {this.props.transactions.length > 0
                          ? new Intl.NumberFormat('en-GB', {
                              style: 'currency',
                              currency: 'NGN',
                            }).format(
                              this.props.transactions
                                .filter((t) => t.type === 'Withdrawn')
                                .map((t) => t.amount)
                                .reduce((a, b) => Number(a) + Number(b), 0)
                            )
                          : new Intl.NumberFormat('en-GB', {
                              style: 'currency',
                              currency: 'NGN',
                            }).format(0)}
                      </small>
                      <Icon f7="number_square" slot="media" />
                    </ListItem>
                    {this.props.wallets &&
                      this.props.wallets[
                        this.props.partners[this.props.auth.uid].walletId
                      ] && (
                        <ListItem title="Wallet balance">
                          <small slot="after">
                            {new Intl.NumberFormat('en-GB', {
                              style: 'currency',
                              currency: 'NGN',
                            }).format(
                              Number(
                                this.props.wallets[
                                  this.props.partners[this.props.auth.uid]
                                    .walletId
                                ].walletBalance
                              )
                            )}
                          </small>
                          <Icon f7="number_square" slot="media" />
                        </ListItem>
                      )}
                  </List>
                </CardContent>
              </Card>

              {/* [Card-2] Make a Withdrawal*/}
              {this.props.wallets &&
              this.props.wallets[
                this.props.partners[this.props.auth.uid].walletId
              ] ? (
                this.props.wallets[
                  this.props.partners[this.props.auth.uid].walletId
                ].ban ? (
                  <Card style={{ margin: '17pt auto' }} inner accordionList>
                    <AccordionItem>
                      <CardHeader>
                        Withdrawal
                        <AccordionToggle>
                          <Button
                            outline
                            iconF7="arrowtriangle_down_fill"></Button>
                        </AccordionToggle>
                      </CardHeader>

                      <AccordionContent>
                        <CardContent padding={false}>
                          <Block className="pab">
                            <Row>
                              <Col>
                                <p>Access Revoked &nbsp;&nbsp;&nbsp;</p>
                              </Col>
                              <Col>
                                <Link
                                  className="pal"
                                  tabLink="#view-message-master"
                                  onClick={() =>
                                    this.navMessage(
                                      'account',
                                      'admin',
                                      'account'
                                    )
                                  }>
                                  Contact Admin
                                </Link>
                              </Col>
                            </Row>

                            <Row className="pat">
                              <Col>
                                <p style={{ margin: '0', color: ' #9E9E9E' }}>
                                  Suspicious activity detected on your account.
                                  Your acccount has been banned from making a
                                  withdrawal please contact admin.
                                </p>
                              </Col>
                            </Row>
                          </Block>
                        </CardContent>
                      </AccordionContent>
                    </AccordionItem>
                  </Card>
                ) : (
                  <Card style={{ margin: '10pt auto' }} inner accordionList>
                    <AccordionItem>
                      <CardHeader>
                        Make a withdrawal
                        <AccordionToggle>
                          <Button
                            outline
                            iconF7="arrowtriangle_down_fill"></Button>
                        </AccordionToggle>
                      </CardHeader>

                      <AccordionContent>
                        <CardContent>
                          <List noHairlinesMd>
                            {this.props.wallets[
                              this.props.partners[this.props.auth.uid].walletId
                            ].pendingWithdrawal &&
                            this.props.wallets[
                              this.props.partners[this.props.auth.uid].walletId
                            ].pendingWithdrawal.length > 0
                              ? this.props.wallets[
                                  this.props.partners[this.props.auth.uid]
                                    .walletId
                                ].pendingWithdrawal.map((pw, i) => (
                                  <ListItem
                                    key={i}
                                    header="Pending Withdrawal"
                                    title={`#${pw.amount / 100}`}
                                    footer={
                                      pw.status ? 'Processing' : 'Failed'
                                    }>
                                    <Button
                                      round
                                      fill
                                      slot="after-title"
                                      disabled={pw.status}
                                      onClick={() => this.withdrawalRetry(pw)}
                                      className="button button-fill-blue"
                                      style={{
                                        minWidth: '20%',
                                      }}>
                                      Retry
                                    </Button>
                                  </ListItem>
                                ))
                              : null}
                            <ListItem title="Transfer charge">
                              <small slot="after">
                                {`NGN${payStackTransferCharge(
                                  this.state.withdrawalInfo.amount
                                )}`}
                              </small>
                              <Icon f7="creditcard" slot="media" />
                            </ListItem>
                            <ListInput
                              label="Bank account"
                              type="select"
                              name="account"
                              placeholder="Select account"
                              onChange={(e) =>
                                this.setState({
                                  ...this.state,
                                  withdrawalInfo: {
                                    ...this.state.withdrawalInfo,
                                    recipientCode: e.target.value,
                                  },
                                })
                              }
                              style={{ paddingLeft: 0 }}>
                              <Icon f7="briefcase" slot="media" />
                              <option></option>
                              {this.props.wallets &&
                                this.props.wallets[
                                  this.props.partners[this.props.auth.uid]
                                    .walletId
                                ] &&
                                this.props.wallets[
                                  this.props.partners[this.props.auth.uid]
                                    .walletId
                                ].bankDetails.map(
                                  (
                                    { accountName, bankName, recipientCode },
                                    i
                                  ) => (
                                    <Fragment key={i}>
                                      <option value={recipientCode}>
                                        {accountName} - {bankName}
                                      </option>
                                    </Fragment>
                                  )
                                )}
                            </ListInput>

                            <ListInput
                              label="Amount to withdraw"
                              type="number"
                              min="5000"
                              placeholder="Minimum withdrawal is NGN1,000"
                              info="Minimum withdrawal is NGN1,000"
                              required
                              clearButton
                              value={this.state.withdrawalInfo.amount}
                              onChange={(e) =>
                                this.setState({
                                  ...this.state,
                                  withdrawalInfo: {
                                    ...this.state.withdrawalInfo,
                                    amount: e.target.value,
                                  },
                                })
                              }
                              style={{ paddingLeft: 0 }}>
                              <Icon f7="creditcard_fill" slot="media" />
                            </ListInput>
                          </List>
                        </CardContent>
                        <CardFooter>
                          <Button
                            round
                            fill
                            disabled={
                              this.state.withdrawalButton !==
                              'Confirm Transaction'
                            }
                            onClick={this.initiateTransfer.bind(this)}
                            className="button button-fill-blue"
                            style={{
                              width: '100%',
                              margin: '5pt auto',
                            }}>
                            {this.state.withdrawalButton ===
                            'Confirm Transaction' ? (
                              this.state.withdrawalButton
                            ) : (
                              <Preloader></Preloader>
                            )}
                          </Button>
                        </CardFooter>
                      </AccordionContent>
                    </AccordionItem>
                  </Card>
                )
              ) : null}
            </Col>

            <Col width="100" className="xsmall-60">
              {/* [Card-3] Bank Details*/}
              <Card
                className="data-table data-table-init heightMeasure-2"
                style={{ width: '100%', marginLeft: '0px' }}>
                <CardHeader>
                  <div className="data-table-title">Bank Details</div>
                  <div className="data-table-actions">
                    <Button
                      outline
                      iconF7="plus_circle"
                      onClick={() => {
                        this.$f7.preloader.show();
                        fetchBanks((error, banks) => {
                          if (error) {
                            toast(this.$f7.toast, {
                              text: 'Something went wrong. Try again',
                              position: 'bottom',
                              horizontalPosition: 'center',
                              closeButton: true,
                              cssClass: 'custom-toast',
                              closeTimeout: 4000,
                            });
                            return this.$f7.preloader.hide();
                          }
                          this.setState({
                            ...this.state,
                            banks,
                            popupOpened: true,
                            popupDataChanged: true,
                            popupData: {
                              title: 'Add Bank Details',
                              which: 'add-bank',
                            },
                          });
                          this.$f7.preloader.hide();
                        });
                      }}>
                      &nbsp;&nbsp;&nbsp;Add Bank
                    </Button>
                  </div>
                </CardHeader>
                <CardContent padding={false}>
                  {this.props.loadingDoc && !this.props.wallets ? (
                    <Block className="text-align-center">
                      <Preloader></Preloader>
                    </Block>
                  ) : !this.props.loadingDoc &&
                    (!this.props.wallets ||
                      !this.props.wallets[
                        this.props.partners[this.props.auth.uid].walletId
                      ]) ? (
                    <Block
                      style={{
                        backgroundColor: '#ffe0b2',
                        borderLeft: '3px solid #ff9800',
                        color: '#ef6c00',
                        marginTop: 0,
                        paddingTop: '16px',
                        paddingBottom: '16px',
                      }}>
                      <small>
                        You don't have a wallet! Please add bank details.
                      </small>
                    </Block>
                  ) : (
                    <table>
                      <thead>
                        <tr>
                          <th>
                            <span className="table-head-label">SNo.</span>
                          </th>
                          <th>
                            <span className="table-head-label">
                              Business Bank Account Name
                            </span>
                          </th>
                          <th>
                            <span className="table-head-label">
                              Account Number
                            </span>
                          </th>
                          <th>
                            <span className="table-head-label">Bank Name</span>
                          </th>
                          <th>
                            <span className="table-head-label">Action</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.wallets[
                          this.props.partners[this.props.auth.uid].walletId
                        ] &&
                        this.props.wallets[
                          this.props.partners[this.props.auth.uid].walletId
                        ].bankDetails.length > 0 ? (
                          this.props.wallets[
                            this.props.partners[this.props.auth.uid].walletId
                          ].bankDetails.map(
                            (
                              {
                                bankName,
                                accountName,
                                accountNumber,
                                recipientCode,
                              },
                              i
                            ) => (
                              <tr key={i}>
                                <td> {i + 1} </td>
                                <td>
                                  <div>{accountName}</div>
                                </td>
                                <td>{accountNumber}</td>
                                <td>
                                  <div>{bankName}</div>
                                </td>
                                <td>
                                  <Button
                                    fill
                                    style={{
                                      backgroundImage:
                                        'linear-gradient(#FF6969, #E02020)',
                                      color: 'white',
                                      maxWidth: '41px',
                                    }}
                                    iconF7="trash_circle"
                                    onClick={() =>
                                      this.deleteBank(i, recipientCode)
                                    }></Button>
                                </td>
                              </tr>
                            )
                          )
                        ) : (
                          <tr>
                            <td colSpan="5">
                              <Block
                                style={{
                                  backgroundColor: '#b3e5ff',
                                  borderLeft: '3px solid #03a9f4',
                                  color: '#03a9f4',
                                  marginTop: 0,
                                  paddingTop: '16px',
                                  paddingBottom: '16px',
                                  width: '100%',
                                }}>
                                <small>No bank account registered</small>
                              </Block>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  )}
                </CardContent>
              </Card>

              {/* [Card-4] Referred Vendors*/}
              <Card
                className="data-table data-table-init"
                style={{ width: '100%', marginLeft: '0px' }}>
                <CardHeader>
                  <div className="data-table-title">Referred Vendors</div>
                </CardHeader>
                {!this.props.loadingDoc &&
                this.props.assignedVendors.length > 0 ? (
                  <CardContent padding={false} className="heightRecieve-1">
                    <table>
                      <thead>
                        <tr>
                          <th>
                            <span className="table-head-label">SNo.</span>
                          </th>
                          <th>
                            <span className="table-head-label">
                              Vendor Name
                            </span>
                          </th>
                          <th>
                            <span className="table-head-label">
                              Vendor Type
                            </span>
                          </th>
                          <th>
                            <span className="table-head-label">Registered</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.assignedVendors.map((vendor, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>
                              <div>{vendor.businessProfile.name}</div>
                            </td>
                            <td>
                              {vendor.businessProfile.ownsDelivery
                                ? 'Merchant'
                                : 'Delivery'}
                            </td>
                            <td>
                              <div>{moment(vendor.timestamp).fromNow()}</div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </CardContent>
                ) : (
                  <CardContent padding={false}>
                    <Block className="block-info">
                      <Row>
                        <Col>
                          <p>No referred vendors!</p>
                        </Col>
                      </Row>
                    </Block>
                  </CardContent>
                )}
                <CardFooter className="easyPrintText">
                  <pre>
                    <small>
                      You have referred{' '}
                      <b>{this.props.assignedVendors.length}</b> vendor(s)
                    </small>
                  </pre>
                </CardFooter>
              </Card>
            </Col>

            <Col width="100">
              {/* [Card-5] Transactions*/}
              <Card
                className="data-table data-table-init"
                style={{ width: '100%', marginLeft: '0px' }}>
                <CardHeader>
                  <div className="data-table-title">Transactions</div>
                </CardHeader>
                {this.props.transactions.length > 0 ? (
                  <CardContent padding={false}>
                    <table>
                      <thead>
                        <tr>
                          <th>
                            <span className="table-head-label">SNo.</span>
                          </th>
                          <th>
                            <span className="table-head-label">Wallet ID</span>
                          </th>
                          <th>
                            <span className="table-head-label">
                              Transaction ID
                            </span>
                          </th>
                          <th>
                            <span className="table-head-label">Order ID</span>
                          </th>
                          <th>
                            <span className="table-head-label">Commission</span>
                          </th>
                          <th>
                            <span className="table-head-label">Type</span>
                          </th>
                          <th>
                            <span className="table-head-label">
                              Business Name
                            </span>
                          </th>
                          <th>
                            <span className="table-head-label">Status</span>
                          </th>
                          <th>
                            <span className="table-head-label">Timestamp</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.transactions
                          .sort((a, b) => b.timestamp - a.timestamp)
                          .map(
                            (
                              {
                                id,
                                walletId,
                                type,
                                amount,
                                orderAmount,
                                orderId,
                                businessName,
                                timestamp,
                                status,
                              },
                              i
                            ) => (
                              <tr key={id}>
                                <td>{i + 1}</td>
                                <td>{walletId}</td>
                                <td>{id}</td>
                                <td>
                                  <div>{orderId ? orderId : '-'}</div>
                                </td>
                                <td
                                  style={{
                                    color:
                                      status === 'Success' &&
                                      type === 'Received'
                                        ? 'green'
                                        : 'red',
                                  }}>
                                  <div>
                                    {new Intl.NumberFormat('en-GB', {
                                      style: 'currency',
                                      currency: 'NGN',
                                    }).format(amount)}
                                  </div>
                                </td>
                                <td>
                                  {type === 'Received' && status === 'Failed'
                                    ? 'Declined'
                                    : type}
                                </td>
                                <td>{businessName ? businessName : ''}</td>
                                <td
                                  style={{
                                    color:
                                      status === 'Success' ? 'green' : 'red',
                                  }}>
                                  {status}
                                </td>
                                <td>
                                  <div>{moment(timestamp).fromNow()}</div>
                                </td>
                              </tr>
                            )
                          )}
                      </tbody>
                    </table>
                  </CardContent>
                ) : (
                  <CardContent padding={false}>
                    <Block className="block-info">
                      <Row>
                        <Col>
                          <p>No transactions available at the moment</p>
                        </Col>
                      </Row>
                    </Block>
                  </CardContent>
                )}
              </Card>
            </Col>
          </Row>
        </Block>

        {/* Popup for forms */}
        <Popup
          swipeToClose="to-bottom"
          className="easychaw-popup"
          opened={this.state.popupOpened}
          onPopupClosed={() =>
            this.setState({
              popupOpened: false,
              popupDataChanged: false,
              popupData: { title: '', which: '' },
            })
          }>
          <Page>
            <Navbar title={this.state.popupData.title}>
              <NavRight>
                <Link popupClose>Close</Link>
              </NavRight>
            </Navbar>

            {/* Content for add bank details */}
            {this.state.popupData.which == 'add-bank' ? (
              <Block>
                <Card style={{ margin: 'auto' }}>
                  <CardHeader className="no-border">
                    <h1
                      style={{
                        marginTop: 0,
                        marginBottom: 0,
                        fontSize: '40px',
                      }}>
                      Bank Account Editor
                    </h1>
                  </CardHeader>
                  <CardContent>
                    <List noHairlinesMd form id="bank-editor">
                      <ListInput
                        label="Bank account number"
                        type="number"
                        placeholder="eg: 0123456789"
                        info="Bank account number is required"
                        required
                        validate
                        clearButton
                        value={this.state.bank.accountNumber}
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            bank: {
                              ...this.state.bank,
                              accountNumber: e.target.value,
                            },
                          })
                        }>
                        <Icon f7="creditcard_fill" slot="media" />
                      </ListInput>

                      <ListInput
                        label="Bank account name"
                        type="text"
                        info="Account name is automated"
                        disabled={true}
                        value={this.state.bank.accountName}
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            bank: {
                              ...this.state.bank,
                              accountName: e.target.value,
                            },
                          })
                        }>
                        <Icon f7="briefcase" slot="media" />
                      </ListInput>

                      <ListInput
                        label="Bank name"
                        type="select"
                        name="bank"
                        style={{ paddingLeft: 0 }}
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            bank: {
                              ...this.state.bank,
                              bankName: e.target.value,
                              bankCode: this.state.banks.find(
                                (bank) => bank.name === e.target.value
                              ).code,
                            },
                          })
                        }>
                        <Icon f7="car_fill" slot="media" />
                        <option></option>
                        {this.state.banks.map((bank) => (
                          <option key={bank.name} value={bank.name}>
                            {bank.name}
                          </option>
                        ))}

                        <Icon f7="building_2_fill" slot="media" />
                      </ListInput>

                      <ListInput
                        label="Bank sort code"
                        type="text"
                        placeholder="Type sort code of account here"
                        info="Bank sort code is optional"
                        clearButton
                        value={this.state.bank.sortCode}
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            bank: {
                              ...this.state.bank,
                              sortCode: e.target.value,
                            },
                          })
                        }>
                        <Icon f7="building_2_fill" slot="media" />
                      </ListInput>
                    </List>
                  </CardContent>
                  <CardFooter>
                    <Button
                      round
                      fill
                      disabled={
                        this.state.addBankButton !== 'Upload Bank Details'
                      }
                      style={{ width: '100%' }}
                      onClick={this.addBank.bind(this)}>
                      {this.state.addBankButton} &nbsp;{' '}
                      {this.state.addBankButton !== 'Upload Bank Details' && (
                        <Preloader></Preloader>
                      )}
                    </Button>
                  </CardFooter>
                </Card>
              </Block>
            ) : null}
          </Page>
        </Popup>
      </Page>
    );
  }

  componentDidUpdate(prevProps) {
    // Auto update wallet name
    if (
      (!prevProps.wallets ||
        (prevProps.partners[prevProps.auth.uid] &&
          !prevProps.wallets[
            prevProps.partners[prevProps.auth.uid].walletId
          ])) &&
      this.props.wallets &&
      this.props.partners[this.props.auth.uid] &&
      this.props.wallets[this.props.partners[this.props.auth.uid].walletId] &&
      !this.props.wallets[this.props.partners[this.props.auth.uid].walletId]
        .name
    ) {
      this.props.firestore
        .collection('wallets')
        .doc(this.props.partners[this.props.auth.uid].walletId)
        .update({
          name: this.props.partners[this.props.auth.uid].businessProfile.name,
        })
        .catch((error) => {});
    }
  }

  // events
  onPageAfterIn() {
    const self = this;
    setTimeout(function () {
      const h1 = self.$f7.$('.heightMeasure-1').height();
      const h2 = self.$f7.$('.heightMeasure-2').height();
      self.$f7.$('.heightRecieve-1').css({ height: `${h1 - h2 - 136}px` });
    }, 1000);
  }

  navMessage(...args) {
    const self = this;
    const messageReceiverID = args[1] ? args[1] : 'admin';
    const previousView = args[0] ? args[0] : 'account';
    const previousPage = args[2] ? args[2] : 'account';

    self.$f7.views['message-master'].router.navigate(
      {
        name: 'message-master',
        params: {
          view: previousView,
          id: messageReceiverID,
          page: previousPage,
        },
      },
      {
        reloadAll: true,
      }
    );
  }

  withdrawalRetry(pw) {
    this.$f7.preloader.show();
    // make transfer
    const transferDetails = {
      amount: pw.amount,
      recipient: pw.recipient,
      reason: {
        walletId: pw.reason.walletId,
        email: pw.reason.email,
        commission: pw.reason.commission,
      },
      retry: {
        reference: pw.reference,
      },
    };

    this.props.firebase
      .auth()
      .currentUser.getIdToken(true)
      .then((idToken) => {
        transferDetails.token = idToken;
        transferDetails.uid = this.props.auth.uid;

        // initiate transfer
        initiateATransfer(transferDetails, (error, data) => {
          if (error) {
            this.$f7.preloader.hide();
            return toast(this.$f7.toast, {
              text: error,
              position: 'bottom',
              horizontalPosition: 'center',
              closeButton: true,
              cssClass: 'custom-toast',
              closeTimeout: 4000,
            });
          }

          this.$f7.preloader.hide();
          return this.$f7.dialog.alert(
            'Processing transaction, you will recieve a mail shortly'
          );
        });
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      });
  }

  initiateTransfer() {
    this.$f7.preloader.show();
    this.setState({
      ...this.state,
      withdrawalButton: '',
    });

    if (!this.props.wallets) {
      this.setState({
        ...this.state,
        withdrawalButton: 'Confirm Transaction',
      });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: 'Please add a bank detail',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    const walletBalance = this.props.wallets[
      this.props.partners[this.props.auth.uid].walletId
    ].walletBalance;

    const pendingWithdrawal = this.props.wallets[
      this.props.partners[this.props.auth.uid].walletId
    ].pendingWithdrawal
      ? this.props.wallets[
          this.props.partners[this.props.auth.uid].walletId
        ].pendingWithdrawal
          .map((pw) => pw.amount / 100 + pw.reason.commission)
          .reduce((a, b) => a + b, 0)
      : 0;

    if (this.state.withdrawalInfo.recipientCode === '') {
      this.setState({
        ...this.state,
        withdrawalButton: 'Confirm Transaction',
      });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: 'Select a bank account',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    if (this.state.withdrawalInfo.amount < 1000) {
      this.setState({
        ...this.state,
        withdrawalButton: 'Confirm Transaction',
      });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: 'Mininmum withdrawal is NGN1,000',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    if (
      +this.state.withdrawalInfo.amount +
        +payStackTransferCharge(this.state.withdrawalInfo.amount) >
      +walletBalance - pendingWithdrawal
    ) {
      this.setState({
        ...this.state,
        withdrawalButton: 'Confirm Transaction',
      });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: 'Insufficient Balance',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    const bankAccount = this.props.wallets[
      this.props.partners[this.props.auth.uid].walletId
    ].bankDetails.find(
      ({ recipientCode }) =>
        recipientCode === this.state.withdrawalInfo.recipientCode
    );
    this.$f7.preloader.hide();

    this.$f7.dialog.confirm(
      `
    <p><strong>Bank:</strong> ${bankAccount.bankName}</p>
    <p><strong>Account Name:</strong> ${bankAccount.accountName}</p>
    <p><strong>Account Number:</strong> ${bankAccount.accountNumber}</p>
    <p><strong>Amount:</strong> ${new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'NGN',
    }).format(+this.state.withdrawalInfo.amount)}</p>
    <p>You will be charged <strong>${new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'NGN',
    }).format(
      +payStackTransferCharge(this.state.withdrawalInfo.amount)
    )}</strong> for this transaction.</p>
    `,
      'Confirm Transaction',
      () => {
        // make transfer
        const transferDetails = {
          amount: `${+this.state.withdrawalInfo.amount * 100}`,
          recipient: this.state.withdrawalInfo.recipientCode,
          reason: {
            walletId: this.props.partners[this.props.auth.uid].walletId,
            email: this.props.partners[this.props.auth.uid].businessProfile
              .email,
            commission: +payStackTransferCharge(
              this.state.withdrawalInfo.amount
            ),
          },
        };
        this.$f7.preloader.show();

        this.props.firebase
          .auth()
          .currentUser.getIdToken(true)
          .then((idToken) => {
            transferDetails.token = idToken;
            transferDetails.uid = this.props.auth.uid;

            // send OTP to merchant's email
            sendOneTimePassword(
              { type: 'partners', token: idToken, uid: this.props.auth.uid },
              (error, sent) => {
                if (error || !sent) {
                  this.setState({
                    ...this.state,
                    withdrawalButton: 'Confirm Transaction',
                  });
                  this.$f7.preloader.hide();
                  return toast(this.$f7.toast, {
                    text: error,
                    position: 'bottom',
                    horizontalPosition: 'center',
                    closeButton: true,
                    cssClass: 'custom-toast',
                    closeTimeout: 4000,
                  });
                }

                // open a dialog to confirm OTP
                this.$f7.preloader.hide();
                this.$f7.dialog
                  .create({
                    title: 'OTP CODE',
                    cssClass: 'otp-code-modal',
                    text:
                      'Confirm withdrawal by filling in the OTP code sent to your email address',
                    content: `<input class="dialog-input split-input" type="password" maxlength="4"/>`,
                    buttons: [
                      // button to resend otp
                      {
                        text: 'Resend Code',
                        color: 'gray',
                        cssClass: 'otp-resend',

                        close: false,
                        onClick: (dialog, e) => {
                          this.$f7.preloader.show();
                          sendOneTimePassword(
                            {
                              type: 'partners',
                              token: idToken,
                              uid: this.props.auth.uid,
                            },
                            (error, sent) => {
                              if (error || !sent) {
                                this.setState({
                                  ...this.state,
                                  withdrawalButton: 'Confirm Transaction',
                                });
                                this.$f7.preloader.hide();
                                return toast(this.$f7.toast, {
                                  text: error,
                                  position: 'bottom',
                                  horizontalPosition: 'center',
                                  closeButton: true,
                                  cssClass: 'custom-toast',
                                  closeTimeout: 4000,
                                });
                              }

                              this.$f7.preloader.hide();
                              return toast(this.$f7.toast, {
                                text: 'OTP code sent',
                                position: 'bottom',
                                horizontalPosition: 'center',
                                closeButton: true,
                                cssClass: 'custom-toast',
                                closeTimeout: 4000,
                              });
                            }
                          );
                        },
                      },
                      // button to cancel
                      {
                        text: 'x',
                        color: 'white',
                        cssClass: 'otp-close',
                        onClick: (dialog, e) => {
                          this.setState({
                            ...this.state,
                            withdrawalButton: 'Confirm Transaction',
                          });
                          this.$f7.preloader.hide();
                        },
                      },
                      // button to continue
                      {
                        text: 'Continue',
                        bold: true,
                        cssClass: 'otp-continue',
                        keyCodes: [13],
                        close: false,
                        onClick: (dialog, e) => {
                          this.$f7.preloader.show();
                          // password
                          const password = dialog.$el
                            .find('.dialog-input')
                            .val();

                          // Verify otp
                          verifyOneTimePassword(
                            {
                              password,
                              type: 'partners',
                              token: idToken,
                              uid: this.props.auth.uid,
                            },
                            (error, success) => {
                              if (error || !success) {
                                this.setState({
                                  ...this.state,
                                  withdrawalButton: 'Confirm Transaction',
                                });
                                this.$f7.preloader.hide();
                                return toast(this.$f7.toast, {
                                  text: error,
                                  position: 'bottom',
                                  horizontalPosition: 'center',
                                  closeButton: true,
                                  cssClass: 'custom-toast',
                                  closeTimeout: 4000,
                                });
                              }

                              // close dialog
                              dialog.close();

                              // initiate transfer
                              initiateATransfer(
                                transferDetails,
                                (error, data) => {
                                  if (error) {
                                    this.setState({
                                      ...this.state,
                                      withdrawalButton: 'Confirm Transaction',
                                    });
                                    this.$f7.preloader.hide();
                                    return toast(this.$f7.toast, {
                                      text:
                                        'Something went wrong, Please try again or contact admin',
                                      position: 'bottom',
                                      horizontalPosition: 'center',
                                      closeButton: true,
                                      cssClass: 'custom-toast',
                                      closeTimeout: 4000,
                                    });
                                  }

                                  this.setState({
                                    ...this.state,
                                    withdrawalButton: 'Confirm Transaction',
                                    withdrawalInfo: {
                                      ...this.state.withdrawalInfo,
                                      amount: 0,
                                    },
                                  });
                                  this.$f7.preloader.hide();
                                  return toast(this.$f7.toast, {
                                    text:
                                      'Processing transaction, you will recieve a mail shortly',
                                    position: 'bottom',
                                    horizontalPosition: 'center',
                                    closeButton: true,
                                    cssClass: 'custom-toast',
                                    closeTimeout: 4000,
                                  });
                                }
                              );
                            }
                          );
                        },
                      },
                    ],
                    destroyOnClose: true,
                  })
                  .open();
              }
            );
          })
          .catch((error) => {
            this.setState({
              ...this.state,
              withdrawalButton: 'Confirm Transaction',
            });
            this.$f7.preloader.hide();
            return toast(this.$f7.toast, {
              text: handleErrors(error),
              position: 'bottom',
              horizontalPosition: 'center',
              closeButton: true,
              cssClass: 'custom-toast',
              closeTimeout: 4000,
            });
          });
      },
      () => {
        this.$f7.preloader.hide();
        this.setState({
          ...this.state,
          withdrawalButton: 'Confirm Transaction',
        });
      }
    );
  }

  addBank() {
    this.$f7.preloader.show();
    this.setState({ ...this.state, addBankButton: '' });
    const bankDetails = {
      ...this.state.bank,
    };

    if (isEmpty(bankDetails.accountNumber)) {
      this.setState({ ...this.state, addBankButton: 'Upload Bank Details' });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: 'Account Number is required.',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    if (isEmpty(bankDetails.bankName)) {
      this.setState({ ...this.state, addBankButton: 'Upload Bank Details' });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: 'Bank Name is required.',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    if (this.state.BanksWithIssues.includes(bankDetails.bankName)) {
      this.setState({ ...this.state, addBankButton: 'Upload Bank Details' });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: "We have issue with this bank's API, please choose another bank.",
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    this.props.firebase
      .auth()
      .currentUser.getIdToken(true)
      .then((idToken) => {
        resolveAccountNumber(
          bankDetails.accountNumber,
          bankDetails.bankCode,
          idToken,
          this.props.auth.uid,
          (error, data) => {
            this.$f7.preloader.hide();
            if (error) {
              this.setState({
                ...this.state,
                addBankButton: 'Upload Bank Details',
              });
              return toast(this.$f7.toast, {
                text: error,
                position: 'bottom',
                horizontalPosition: 'center',
                closeButton: true,
                cssClass: 'custom-toast',
                closeTimeout: 4000,
              });
            }

            this.$f7.dialog.confirm(
              `Please confirm your account name: ${data.account_name}`,
              'Account Name',
              () => {
                this.setState({
                  ...this.state,
                  bank: {
                    ...this.state.bank,
                    accountName: data.account_name,
                  },
                });
                this.$f7.preloader.show();
                bankDetails.accountName = data.account_name;

                createTransferRecipient(
                  {
                    ...bankDetails,
                    token: idToken,
                    uid: this.props.auth.uid,
                    wallet: 'partner',
                  },
                  (error, recipientCode) => {
                    if (error) {
                      this.setState({
                        ...this.state,
                        addBankButton: 'Upload Bank Details',
                      });
                      this.$f7.preloader.hide();
                      return toast(this.$f7.toast, {
                        text: 'Something went wrong. Try again.',
                        position: 'bottom',
                        horizontalPosition: 'center',
                        closeButton: true,
                        cssClass: 'custom-toast',
                        closeTimeout: 4000,
                      });
                    }

                    bankDetails.recipientCode = recipientCode;

                    if (this.props.wallets) {
                      // update
                      const walletId = Object.keys(this.props.wallets)[0];
                      const update = [
                        ...this.props.wallets[
                          this.props.partners[this.props.auth.uid].walletId
                        ].bankDetails,
                        {
                          ...bankDetails,
                        },
                      ];

                      addOrRemoveBank(
                        walletId,
                        update,
                        idToken,
                        this.props.auth.uid,
                        (error, bankAdded) => {
                          if (error) {
                            this.setState({
                              ...this.state,
                              addBankButton: 'Upload Bank Details',
                            });
                            this.$f7.preloader.hide();
                            return toast(this.$f7.toast, {
                              text: handleErrors(error),
                              position: 'bottom',
                              horizontalPosition: 'center',
                              closeButton: true,
                              cssClass: 'custom-toast',
                              closeTimeout: 4000,
                            });
                          }

                          this.setState({
                            ...this.state,
                            popupOpened: false,
                            addBankButton: 'Upload Bank Details',
                            bank: {
                              ...this.state.bank,
                              bankName: '',
                              accountName: '',
                              accountNumber: '',
                              sortCode: '',
                              bankCode: '',
                            },
                          });
                          this.$f7.preloader.hide();
                          return toast(this.$f7.toast, {
                            text: 'Bank Profile Uploaded',
                            position: 'bottom',
                            horizontalPosition: 'center',
                            closeButton: true,
                            cssClass: 'custom-toast',
                            closeTimeout: 4000,
                          });
                        }
                      );
                    } else {
                      // new
                      const walletId = generateId(7);
                      const wallet = {
                        walletBalance: 0,
                        transactions: [],
                        bankDetails: [bankDetails],
                      };
                      this.props.firestore
                        .collection('partners')
                        .doc(this.props.auth.uid)
                        .update({ walletId })
                        .then(() => {
                          addOrRemoveBank(
                            walletId,
                            wallet,
                            idToken,
                            this.props.auth.uid,
                            (error, bankAdded) => {
                              if (error) {
                                this.setState({
                                  ...this.state,
                                  addBankButton: 'Upload Bank Details',
                                });
                                this.$f7.preloader.hide();
                                return toast(this.$f7.toast, {
                                  text: handleErrors(error),
                                  position: 'bottom',
                                  horizontalPosition: 'center',
                                  closeButton: true,
                                  cssClass: 'custom-toast',
                                  closeTimeout: 4000,
                                });
                              }

                              this.setState({
                                ...this.state,
                                popupOpened: false,
                                addBankButton: 'Upload Bank Details',
                                bank: {
                                  ...this.state.bank,
                                  bankName: '',
                                  accountName: '',
                                  accountNumber: '',
                                  sortCode: '',
                                  bankCode: '',
                                },
                              });
                              this.$f7.preloader.hide();
                              return toast(this.$f7.toast, {
                                text: 'Bank Profile Uploaded',
                                position: 'bottom',
                                horizontalPosition: 'center',
                                closeButton: true,
                                cssClass: 'custom-toast',
                                closeTimeout: 4000,
                              });
                            }
                          );
                        })
                        .catch((error) => {
                          this.setState({
                            ...this.state,
                            addBankButton: 'Upload Bank Details',
                          });
                          return toast(this.$f7.toast, {
                            text: handleErrors(error),
                            position: 'bottom',
                            horizontalPosition: 'center',
                            closeButton: true,
                            cssClass: 'custom-toast',
                            closeTimeout: 4000,
                          });
                        });
                    }
                  }
                );
              },
              () => {
                this.setState({
                  ...this.state,
                  addBankButton: 'Upload Bank Details',
                });
              }
            );
          }
        );
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          addBankButton: 'Upload Bank Details',
        });
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      });
  }

  deleteBank(index, recipientCode) {
    this.$f7.preloader.show();
    const walletId = this.props.partners[this.props.auth.uid].walletId;
    const bankDetails = [...this.props.wallets[walletId].bankDetails];

    this.props.firebase
      .auth()
      .currentUser.getIdToken(true)
      .then((idToken) => {
        deleteTransferRecipient(
          {
            recipientCode,
            token: idToken,
            uid: this.props.auth.uid,
            wallet: 'partner',
          },
          (error, isDeleted) => {
            if (error) {
              this.$f7.preloader.hide();
              return toast(this.$f7.toast, {
                text:
                  'Something went wrong. Cannot delete account, please try again',
                position: 'bottom',
                horizontalPosition: 'center',
                closeButton: true,
                cssClass: 'custom-toast',
                closeTimeout: 4000,
              });
            }

            bankDetails.splice(index, 1);

            addOrRemoveBank(
              walletId,
              bankDetails,
              idToken,
              this.props.auth.uid,
              (error, bankRemoved) => {
                if (error) {
                  this.$f7.preloader.hide();
                  toast(this.$f7.toast, {
                    text: handleErrors(error),
                    position: 'bottom',
                    horizontalPosition: 'center',
                    closeButton: true,
                    cssClass: 'custom-toast',
                    closeTimeout: 4000,
                  });
                }

                this.$f7.preloader.hide();
                return toast(this.$f7.toast, {
                  text: 'Bank Profile Deleted',
                  position: 'bottom',
                  horizontalPosition: 'center',
                  closeButton: true,
                  cssClass: 'custom-toast',
                  closeTimeout: 4000,
                });
              }
            );
          }
        );
      });
  }
}

const mapStateToProps = ({
  firebase: { auth },
  DB: {
    docs: { loading, transactions, merchantsAssigned, deliveryAssigned },
    data,
  },
}) => ({
  auth,
  data,
  loadingDoc: loading,
  transactions: (transactions && transactions) || [],
  assignedVendors:
    merchantsAssigned && deliveryAssigned
      ? [...merchantsAssigned, ...deliveryAssigned]
      : merchantsAssigned && !deliveryAssigned
      ? [...merchantsAssigned]
      : !merchantsAssigned && deliveryAssigned
      ? [...deliveryAssigned]
      : [],
});

const enhance = compose(
  withStorage,
  firestoreConnect((props) => [
    new Doc(
      'wallets',
      (props.partners &&
        props.partners !== null &&
        props.partners[props.auth.uid] &&
        props.partners[props.auth.uid].walletId &&
        props.partners[props.auth.uid].walletId) ||
        null
    ),

    new AssignedVendorsArray(
      'merchants',
      (props.partners &&
        props.partners[props.auth.uid] &&
        props.partners[props.auth.uid].businessProfile &&
        props.partners[props.auth.uid].businessProfile.referralId) ||
        null,
      'referralAgentId'
    ),
    new DocArray(
      'transactions',
      (props.partners &&
        props.partners[props.auth.uid] &&
        props.partners[props.auth.uid].walletId &&
        props.partners[props.auth.uid].walletId) ||
        null,
      'walletId'
    ),
    new AssignedVendorsArray(
      'delivery',
      (props.partners &&
        props.partners[props.auth.uid] &&
        props.partners[props.auth.uid].businessProfile &&
        props.partners[props.auth.uid].businessProfile.referralId) ||
        null,
      'referralAgentId'
    ),
  ]),
  connect(mapStateToProps)
);

export default enhance(EasychawAgent);
